'use client'

import { usePathname } from 'next/navigation'
import { useSession } from 'next-auth/react'
import SidebarMenu from '@/components/SidebarMenu'
import Header from '@/components/Header'
//import Analytics from '@/utils/analytics'
import ApolloWrapper from '@/utils/apollo-wrapper'
import { useTrackPageVisit } from '@/hooks/useTrackPageVisit'
import React from 'react'

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const { data: session } = useSession();
  const pathname = usePathname();
  const publicRoutes = ['/', '/login', '/register', '/verifyemail', '/terms', '/privacy'];
  const isPublicRoute = !pathname || publicRoutes.includes(pathname);

  useTrackPageVisit(!isPublicRoute);

  if (isPublicRoute) {
      return <>{children}</>
  }

  return (
    <ApolloWrapper>
      <div>
          <SidebarMenu name={session?.user?.name} email={session?.user?.email}/>
          <div className="flex-1 lg:ml-64 h-full lg:h-screen overflow-visible lg:overflow-y-auto">
              <div className="max-w-md mx-auto w-full bg-white lg:max-w-none lg:mx-0 lg:bg-transparent">
                  <div className="sticky top-0 bg-brand-background z-10 shadow-sm bg-brand-background lg:pt-3 lg:pr-2">
                      <Header
                        name={session?.user?.name ?? ''}
                        greet={true}
                        email={session?.user?.email ?? ''}
                      />
                  </div>
                  <section className="bg-white border border-brand-border lg:mr-2">
                      {children}
                  </section>
              </div>
          </div>
          {/* <Analytics /> */}
      
          {/* <div className="lg:hidden">
              <BottomNavigation />
          </div> */}
      </div>
    </ApolloWrapper>
  )
}